export default __webpack_public_path__ + "static/media/yt_thumb_1.1f035c6f.jpg";